import React from 'react';

import cn from 'classnames';
import { string, bool, element, oneOfType } from 'prop-types';

import { NavLink } from 'react-router-dom';

import s from './WithLink.css';

const WithLink = ({ variant, disabled, linkTo, href, children }) => {
  if (disabled) {
    return children;
  }
  if (linkTo) {
    return (
      <NavLink
        className={({ isActive }) =>
          cn({
            [s.selected]: variant === 'sideNav' && isActive,
          })
        }
        end
        to={linkTo}
      >
        {children}
      </NavLink>
    );
  }
  if (href) {
    return <a href={href}>{children}</a>;
  }
  return children;
};

WithLink.propTypes = {
  linkTo: string,
  href: string,
  children: oneOfType([element, string]),
  disabled: bool,
  variant: string,
};

WithLink.defaultProps = {
  linkTo: null,
  href: null,
  disabled: false,
  variant: 'sideNav',
  children: null,
};

export default WithLink;
